import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c9900d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "bodyWrapper" }
const _hoisted_4 = { class: "bodyContent" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Overview", -1))
const _hoisted_6 = ["textContent"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "threadsSection" }, "Threads", -1))
const _hoisted_8 = { class: "threadMessageTitle" }
const _hoisted_9 = { class: "threadMessageSummary" }

import { computed, ComputedRef, Ref, ref } from 'vue';

import ModalDialog, { ModalDialogApi } from '@/components/dialogs/ModalDialog.vue';
import BrowserDetection from '@/data/BrowserDetection';
import { ChatSummary } from '@/data/datatypes/ChatSummary';
import { Track } from '@/data/datatypes/Track';

const MAX_WORKSPACE_TITLE_SIZE: number = 25;
const MAX_THREAD_TITLE_SIZE: number = 75;

interface Props {
  track: Track;
}
interface Emits {
  (e: 'close'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSummaryDialog',
  props: {
    track: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modal: Ref<ModalDialogApi | null> = ref(null);

const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

const mainSummaryText: ComputedRef<string> = computed(() => {
  if (props.track.chatSummaries && props.track.chatSummaries.length > 0) {
    for (const chatSummary of props.track.chatSummaries) {
      if (!chatSummary.parentMessageId) {
        return chatSummary.summary;
      }
    }
  }
  return 'Chat summary not available.';
});

const threadSummaries: ComputedRef<ChatSummary[]> = computed(() => {
  const toReturn: ChatSummary[] = [];
  if (props.track.chatSummaries && props.track.chatSummaries.length > 0) {
    for (const chatSummary of props.track.chatSummaries) {
      if (chatSummary.parentMessageId) {
        toReturn.push(chatSummary);
      }
    }
  }
  return toReturn;
});

const hasThreads: ComputedRef<boolean> = computed(() => {
  return threadSummaries.value.length > 0;
});

const dialogTitle: ComputedRef<string> = computed(() => {
  let ellipsis = false;
  if (props.track.title && props.track.title.length > MAX_WORKSPACE_TITLE_SIZE) {
    ellipsis = true;
  }

  let trackTitle = props.track.title?.substring(0, MAX_WORKSPACE_TITLE_SIZE);
  if (ellipsis) {
    trackTitle = trackTitle + '...';
  }

  if (threadSummaries.value.length > 0) {
    return trackTitle + ' message summaries';
  }
  return trackTitle + ' message summary';
});

function okClicked(): void {
  modal.value?.closeDialog();
  emit('close');
}

function threadMessageToDisplay(chatSummary: ChatSummary): string | undefined {
  let ellipsis = false;
  if (chatSummary.parentMessagePlainText && chatSummary.parentMessagePlainText.length > MAX_THREAD_TITLE_SIZE) {
    ellipsis = true;
  }
  let toReturn = chatSummary.parentMessagePlainText?.substring(0, MAX_THREAD_TITLE_SIZE);
  if (ellipsis) {
    toReturn = toReturn + '...';
  }
  return toReturn;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDialog, {
    ref_key: "modal",
    ref: modal,
    height: "auto",
    width: isMobile.value ? '100%' : '39rem',
    showCloseButton: true,
    onClose: okClicked
  }, {
    heading: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(dialogTitle.value), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "summaryText",
            textContent: _toDisplayString(mainSummaryText.value)
          }, null, 8, _hoisted_6),
          (hasThreads.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threadSummaries.value, (threadSummary) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: threadSummary.parentMessageId,
                    class: "threadMessage"
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(threadMessageToDisplay(threadSummary)), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(threadSummary.summary), 1)
                  ]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["width"]))
}
}

})